import type { IconData } from '@stacksjs/iconify-core'

export const shareAll: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M242.918 16.173h-42.361v88H152A136.27 136.27 0 0 0 28.025 184.2A114.16 114.16 0 0 0 16 235.506v260.667h52.146l49.606-177.756a85.4 85.4 0 0 1 81.993-62.244h.812v88h41.78l164.29-164.29ZM232.557 308.7v-84.527h-32.812A117.5 117.5 0 0 0 86.93 309.815L48 449.315V235.506a82.45 82.45 0 0 1 8.785-37.276l.292-.614A104.22 104.22 0 0 1 152 136.173h80.557V51.067l128.816 128.816Z\"/><path fill=\"currentColor\" d=\"M330.918 15.509h-43.409l164.373 164.374l-163.626 163.626h42.081l164.29-164.29z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default shareAll
